var counter = 0;
var maxAttempts = 10;
var interval = 1000;
var labels = document.querySelectorAll(".rendered-form label");

function callFunctionRepeatedly() {
  labels = document.querySelectorAll(".rendered-form label");
  var inputs = document.querySelectorAll(".rendered-form input");
  var filteredLabels = Array.from(labels).filter(
    (label) => !label.classList.contains("formbuilder-select-label")
  );
  function updateLabelStyle(input, label) {
    if (input.value.trim() !== "" || input === document.activeElement) {
      label.style.top = ".5rem";
      label.style.left = "calc(var(--inputs-border-width) + 2rem)";
      label.style.fontSize = "1rem";
      label.style.letterSpacing = ".04rem";
      if (label.querySelector(".tooltip-element")) {
        label.querySelector(".tooltip-element").style.top = "0rem";
      }

      input.style.padding = "2.2rem 1.5rem .8rem 2rem";
      input.style.margin = "var(--inputs-border-width)";
    } else {
      label.style.top = "calc(1rem + var(--inputs-border-width))";
      label.style.left = "calc(var(--inputs-border-width) + 2rem)";
      label.style.fontSize = "1.6rem";
      label.style.letterSpacing = ".1rem";
      if (label.querySelector(".tooltip-element")) {
        label.querySelector(".tooltip-element").style.top = "-0.2rem";
      }

      input.style.padding = "1.5rem";
      input.style.margin = "var(--inputs-border-width)";
    }
  }

  inputs.forEach((input, index) => {
    updateLabelStyle(input, filteredLabels[index]);
    input.addEventListener("input", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("focus", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("blur", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("click", () => 
      filteredLabels[index].classList.add('hover')
    );
  });
  if (labels.length > 0 || counter >= maxAttempts) {
    console.log("Stopped calling function.");
    return;
  }
  counter++;
  setTimeout(callFunctionRepeatedly, interval);
}

document.addEventListener("DOMContentLoaded", function () {
  callFunctionRepeatedly();
});
